import PropTypes from 'prop-types';
import { BsXLg, BsArrowCounterclockwise } from 'react-icons/bs';

const AgenticChatHeader = ({ phase, onReset, onClose }) => (
	<div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-purple-600 text-white rounded-t-xl">
		<div className="flex items-center gap-2">
			<span className="text-sm font-semibold">KI-Suche</span>
			{phase !== 'idle' && phase !== 'conversing' && (
				<span className="text-xs bg-purple-500 px-2 py-0.5 rounded-full">
					{phase === 'awaiting_approval'
						? 'Bereit'
						: phase === 'previewing'
							? 'Vorschau'
							: phase === 'executing'
								? 'Suche l\u00E4uft'
								: 'Abgeschlossen'}
				</span>
			)}
		</div>
		<div className="flex items-center gap-1">
			<button
				onClick={onReset}
				className="p-1.5 hover:bg-purple-500 rounded-lg transition-colors"
				title="Neue Suche starten"
			>
				<BsArrowCounterclockwise className="w-4 h-4" />
			</button>
			<button
				onClick={onClose}
				className="p-1.5 hover:bg-purple-500 rounded-lg transition-colors"
				title="Schlie\u00DFen"
			>
				<BsXLg className="w-3.5 h-3.5" />
			</button>
		</div>
	</div>
);

AgenticChatHeader.propTypes = {
	phase: PropTypes.string.isRequired,
	onReset: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default AgenticChatHeader;
